import React from 'react';

export const SortingIcon = ({ color = 'gray', size = 24, ...restProps }) => (
  <svg width={size} height={size} viewBox="0 0 6 9" fill="none" xmlns="http://www.w3.org/2000/svg" {...restProps}>
    <path d="M1 6L3 8L5 6" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
    <path d="M3 1V8" stroke={color} />
  </svg>
);
